import { useEffect } from "react";

/**
 * Hook to handle mobile touch events on forge viewer
 * Accepts isMobile as parameter for cases where mobile detection is already done
 */
export const useMobileTouchHandler = (isMobile: boolean, onChangeData: () => void) => {
  useEffect(() => {
    if (!isMobile) return;

    const forgeViewer = document.querySelector("#forge-viewer-clone");

    if (!forgeViewer) return;

    forgeViewer.addEventListener("touchstart", onChangeData);

    return () => {
      forgeViewer.removeEventListener("touchstart", onChangeData);
    };
  }, [isMobile, onChangeData]);
};
